import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminLayout } from './AdminLayout';
import { AdminDashboard } from './pages/AdminDashboard';
import { SystemHealth } from './pages/SystemHealth';  
import { UptimeMonitor } from './pages/UptimeMonitor';
import { WarrantyAnalytics } from './pages/WarrantyAnalytics';
import './AdminTheme.css';

export const AdminModule: React.FC = () => {
  return (
    <div className="admin-container">
      <AdminLayout>
        <Routes>
          <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="/dashboard" element={<AdminDashboard />} />
          <Route path="/system-health" element={<SystemHealth />} />
          <Route path="/uptime" element={<UptimeMonitor />} />
          <Route path="/analytics" element={<WarrantyAnalytics />} />
          <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
        </Routes>
      </AdminLayout>
    </div>
  );
};
